module.exports = __webpack_public_path__ + "static/media/send-icon.b94db6f8.svg";